/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 7th 2022, 7:42:14 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { OSActionButton, OSActionButtonProps } from "ui-widgets";
import { FormInfoPopUpForm, FormInfoPopUpFormProps } from "form-builder/components/FormInfoPopUpForm";
import { FormConfiguration } from "lib/schemas";

export interface AddNewFormButtonProps
  extends Pick<
      FormInfoPopUpFormProps,
      "popUpTitle" | "popUpDescription" | "onAPISaveFormInfoCallBackFn" | "allowedFormTypes"
    >,
    Required<Pick<FormInfoPopUpFormProps, "defaultNewFormConfiguration">>,
    Partial<OSActionButtonProps>,
    Pick<FormConfiguration, "form_type"> {
  buttonTitle?: React.ReactNode;
}

export const AddNewFormButton = (props: AddNewFormButtonProps) => {
  const { buttonTitle = "Add New", onAPISaveFormInfoCallBackFn, popUpTitle, popUpDescription } = props;

  return (
    <FormInfoPopUpForm
      closeFormInfoPopUpFn={null}
      formInfoPopUpOpenState={null}
      defaultNewFormConfiguration={props.defaultNewFormConfiguration}
      popUpTitle={popUpTitle}
      popUpDescription={popUpDescription}
      onAPISaveFormInfoCallBackFn={onAPISaveFormInfoCallBackFn}
      allowedFormTypes={props.allowedFormTypes}
    >
      {({ handleOpen }) => (
        <OSActionButton
          actionStyle={props.actionStyle ?? "add"}
          variant={props.variant ?? "contained"}
          size={props.size ?? "small"}
          onClick={handleOpen}
        >
          {buttonTitle}
        </OSActionButton>
      )}
    </FormInfoPopUpForm>
  );
};
